import { render, staticRenderFns } from "./BaseTreeFlow.vue?vue&type=template&id=280012c2"
import script from "./BaseTreeFlow.vue?vue&type=script&lang=js"
export * from "./BaseTreeFlow.vue?vue&type=script&lang=js"
import style0 from "./BaseTreeFlow.vue?vue&type=style&index=0&id=280012c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports